import { Box } from '@mui/material';
import { E_COMMERCE_STYLES } from 'components/ECommerce/config';
import AboutSection from 'components/mobileLanding/AboutSection';
import Partners from 'components/mobileLanding/Section1';
import Section10 from 'components/mobileLanding/Section10';
import OurTeam from 'components/mobileLanding/Section2';
import CoreServices from 'components/mobileLanding/Section3';
import Portfolio from 'components/mobileLanding/Section4';
import Solutions from 'components/mobileLanding/Section5';
import Feedback from 'components/mobileLanding/Section6';
import Section7 from 'components/mobileLanding/Section7';
import Section9 from 'components/mobileLanding/Section9';
import { lazy, Suspense, useRef } from 'react';

const DefaultNavbar = lazy(() => import('../../components/DefaultNavbar'));
const MetaData = lazy(() => import('../../MetaData'));

export default function Landing() {
  const PreLoad = (
    <div className="h-screen w-100 flex items-center justify-center bg-black">
      {/* <h3 className="text-osperb-blue">Osperb</h3> */}
    </div>
  );
  const portfolioRef = useRef<HTMLDivElement>(null);

  const type = 'web';

  return (
    <>
      <MetaData
        title={'Custom ERP Software, Web & Mobile App Dev Company | Osperb'}
        content={
          'Osperb helps businesses systemise operations and go tech-driven with custom ERP, e-commerce, web and mobile apps built on real workflows.'
        }
        description={
          'Osperb helps businesses systemise operations and go tech-driven with custom ERP, e-commerce, web and mobile apps built on real workflows'
        }
        keyword={
          'custom software development company kerala, ERP NEXT development company kerala, custom software company malappuram, software company malappuram, ERP software development kerala, Shopify e commerce developers , custom ERP developers kerala, enterprise software development kerala, business management software kerala, cloud application development kerala, web application development kerala, custom web app development kerala, mobile app development company kerala, mobile app development company malappuram, android app developers kerala, ios app development kerala, flutter app development kerala, enterprise ecommerce development dubai, ecommerce website development malappuram, custom ecommerce development, ecommerce development malappuram, software development company malappuram, software development company calicut, business automation software kerala, workflow automation software, Steel window factory software kerala, inventory management software development, factory management system development, manufacturing ERP software kerala'}
      />
      <Suspense fallback={PreLoad}>
        <DefaultNavbar />
      </Suspense>

      <main>
        <Box
          sx={{
            position: 'sticky',
            top: 0,
            zIndex: 1,
          }}
        >
          <AboutSection type={type} />
        </Box>

        <Box
          sx={{
            position: 'relative',
            zIndex: 2,
            backgroundColor: '#fff',
            cornerShape: 'squircle',
            borderRadius: '50px 50px 0 0',
          }}
          maxWidth={'100%'}
          margin={E_COMMERCE_STYLES.container.mx}
        >
          {/* Main Content - Scrolls over Feedback */}
          <Box
            sx={{
              position: 'relative',
              zIndex: 2,
            }}
            maxWidth={E_COMMERCE_STYLES.container.maxWidthWeb}
            margin={E_COMMERCE_STYLES.container.mx}
          >
            <Partners type={type} />
            <OurTeam type={type} />
            <CoreServices type={type} />
            <Box ref={portfolioRef}>
              <Portfolio type={type} />
            </Box>
          </Box>

          <Solutions type={type} />
          <Feedback type={type} />

          <Box
            px={3}
            sx={{
              pb: 0,
              backgroundColor: '#000',
            }}
          >
            <Section7 />
          </Box>

          <Section9 type={type} />
          <Section10 type={type} />
        </Box>


      </main>
    </>
  );
}
